var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"p-no-borders",attrs:{"headers":_vm.tableHeaders,"items":_vm.tableItems,"disable-pagination":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(item.name))])]}},{key:"item.income",fn:function(ref){
var item = ref.item;
return [_c('p-currency',{attrs:{"value":item.income}})]}},{key:"item.expenses",fn:function(ref){
var item = ref.item;
return [_c('p-currency',{attrs:{"value":item.expenses}})]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_c('p-currency',{attrs:{"value":item.total}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }